// import '../../App.scss';
import Divider from '../Atoms/Divider';
import BoxDivider from '../Atoms/BoxDivider';
import Card from '../Molecules/Card';
import React, { useState, Component } from 'react';
import CardSlider from './CardSlider';
import ChipSection from '../Molecules/ChipSection'


class WorksSection extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    // this.state = {
    //   example: someInfo,
    // };
  }
  

  render() {
    

    return (
      <div className="flex wrap"> 
        <Divider width="100" height="9" content="Værker og udstillinger" cx="uppercase hidden flex items-bottom bb phone-h-15" icon="⚙️"/>
        {/* <div className="card-container w-100 flex scroll no-scroll-bar">
          <Card />
          <Card />
          <Card />
          <Card />
          <Card />
          <Card />
        </div> */}
        <div className="w-100">
          <CardSlider />
        </div>
        <div className="w-100">
          <ChipSection data=""/>
        </div>
        <div className="w-100">
          <BoxDivider horisontal={true}/>
        </div>
        
      </div>
    
    );
  }
}


export default WorksSection;